export const BASE_TRACKER_URL =
  process.env.REACT_APP_BASE_TRACKER_URL || "https://prod.tracker.cointribune.com";

export const shadowCSS = `
:host {
  position: fixed !important;
  bottom: 20px !important;
  right: 20px !important;
  z-index: 9999 !important;
  width: auto !important;
  height: auto !important;
  display: block !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  contain: layout style;
}

*, *::before, *::after {
  box-sizing: border-box;
  border-width: 0;
  border-style: solid;
  border-color: #e5e7eb;
}

.fixed { position: fixed; }
.absolute { position: absolute; }
.relative { position: relative; }
.inset-0 { inset: 0; }
.bottom-2 { bottom: 0.5rem; }
.bottom-4 { bottom: 1rem; }
.bottom-6 { bottom: 1.5rem; }
.bottom-24 { bottom: 6rem; }
.bottom-32 { bottom: 8rem; }
.right-0 { right: 0rem; }
.right-2 { right: 0.5rem; }
.right-4 { right: 1rem; }
.right-6 { right: 1.5rem; }
.right-12 { right: 3rem; }
.-left-4 { left: -1rem; }
.top-0 { top: 0rem; }
.top-2 { top: 0.5rem; }
.z-1 { z-index: 1; }
.z-10 { z-index: 10; }
.z-40 { z-index: 40; }
.z-50 { z-index: 50; }
.w-1 { width: 0.25rem; }
.w-4 { width: 1rem; }
.w-6 { width: 1.5rem; }
.w-7 { width: 1.75rem; }
.w-8 { width: 2rem; }
.w-9 { width: 2.25rem; }
.w-10 { width: 2.5rem; }
.w-14 { width: 3.5rem; }
.w-16 { width: 4rem; }
.w-20 { width: 5rem; }
.w-36 { width: 9rem; }
.w-56 { width: 14rem; }
.w-80 { width: 20rem; }
.w-full { width: 100%; }
.h-1 { height: 0.25rem; }
.h-4 { height: 1rem; }
.h-6 { height: 1.5rem; }
.h-7 { height: 1.75rem; }
.h-8 { height: 2rem; }
.h-10 { height: 2.5rem; }
.h-12 { height: 3rem; }
.h-14 { height: 3.5rem; }
.h-16 { height: 4rem; }
.h-20 { height: 5rem; }
.h-64 { height: 16rem; }
.h-96 { height: 24rem }
.h-full { height: 100%; }
.flex { display: flex; }
.block { display: block; }
.flex-col { flex-direction: column; }
.justify-center { justify-content: center; }
.justify-evenly { justify-content: space-evenly; }
.justify-around { justify-content: space-around; }
.justify-between { justify-content: space-between; }
.items-center { align-items: center; }
.items-start { align-items: flex-start; }
.pt-1 { padding-top: 0.25rem; }
.pt-8 { padding-top: 2rem; }
.leading-none { line-height: 1; }
.gap-2 { gap: 0.5rem; }
.gap-4 { gap: 1rem; }
.gap-8 { gap: 2rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-5 { padding: 1.25rem; }
.p-6 { padding: 1.5rem; }
.px-1\\.5 { padding-left: 0.375rem; padding-right: 0.375rem; }
.px-3 { padding-left: 0.75rem; padding-right: 0.75rem; }
.px-10 { padding-left: 2.5rem; padding-right: 2.5rem; }
.py-0\\.5 { padding-top: 0.125rem; padding-bottom: 0.125rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.m-0 { margin: 0rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-5 { margin-bottom: 1.25rem; }
.ml-2 { margin-left: 0.5rem; }
.mt-1 { margin-top: 0.25rem; }
.mt-3 { margin-top: 0.75rem; }
.mr-16 { margin-right: 4rem; }
.mx-auto { margin-left: auto; margin-right: auto; }
.text-xs { font-size: 0.75rem; line-height: 1rem; }
.text-sm { font-size: 0.875rem; line-height: 1.25rem; }
.text-lg { font-size: 1.125rem; line-height: 1.75rem; }
.text-xl { font-size: 1.25rem; line-height: 1.75rem; }
.font-bold { font-weight: 700; }
.font-medium { font-weight: 500; }
.text-center { text-align: center; }
.text-white { color: rgb(255 255 255); }
.text-black { color: rgb(0 0 0); }
.text-gray-300 { color: rgb(209 213 219); }
.text-gray-400 { color: rgb(156 163 175); }
.text-red-500 { color: var(--color-danger); }
.text-red-900 { color: rgb(127 29 29); }
.text-orange-400 { color: rgb(251 146 60); }
.text-orange-500 { color: var(--color-primary); }
.text-green-400 { color: rgb(74 222 128); }
.text-green-500 { color: var(--color-success); }
.text-primary { color: var(--color-primary); }
.bg-white { background-color: white; }
.bg-surface { background-color: var(--color-surface); }
.bg { background-color: var(--color-background); }
.bg-primary { background-color: var(--color-primary); }
.bg-red-50 { background-color: rgb(254 242 242); }
.bg-gray-700 { background-color: rgb(55 65 81); }
.bg-gray-800 { background-color: var(--color-surface); }
.bg-gray-900 { background-color: var(--color-background); }
.bg-orange-500 { background-color: var(--color-primary); }
.bg-orange-600 { background-color: rgb(234 88 12); }
.bg-yellow-500 { background-color: var(--color-warning); }
.border-white { border-color: white; }
.border-3 { border-width: 3px; }
.border-4 { border-width: 4px; }
.border-orange-500 { border-color: rgb(249 115 22); }
.border-t-transparent { border-top-color: transparent; }
.rounded-lg { border-radius: 0.5rem; }
.rounded-xl { border-radius: 0.75rem; }
.rounded-tr-2xl { border-top-right-radius: 1rem; }
.rounded-bl-2xl { border-bottom-left-radius: 1rem; }
.rounded { border-radius: 1rem; }
.rounded-full { border-radius: 9999px; }
.shadow-lg { box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1); }
.shadow-xl { box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1); }
.transform { transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)); }
.-rotate-90 { --tw-rotate: -90deg; transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)); }
.transition-colors { transition-property: color, background-color, border-color, text-decoration-color, fill, stroke; transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1); transition-duration: 150ms; }
.cursor-pointer { cursor: pointer; }
.pointer-events-none { pointer-events: none; }
.pointer-events-auto { pointer-events: auto; }
.overflow-hidden { overflow: hidden; }
.object-cover { object-fit: cover; }

.circle-background { padding: 0.25rem; border-radius: 100% }
.circle-background {padding: 0.25rem;border-radius: 100%;background-color: white;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); }
[data-theme="dark"] .circle-background {background-color: #374151;box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6); }
.modal-width { width: 18rem; }
.modal-position { bottom: 5rem; right: 0rem; }
.modal-trigger-position { bottom: 0; right: 0rem; }
.close-btn-shadow { box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 19%) }
.modal-shadow { box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; }

.animate-bounce { animation: bounce 1s infinite; }
.animate-spin { animation: spin 1s linear infinite; }
.animate-scaleIn { animation: scaleIn 0.2s ease-out; }

.hover\\:bg-orange-700:hover { background-color: rgb(194 65 12); }
.hover\\:bg-gray-700:hover { background-color: rgb(55 65 81); }
.hover\\:text-gray-300:hover { color: rgb(209 213 219); }

@keyframes bounce {
  0%, 100% { transform: translateY(-25%); animation-timing-function: cubic-bezier(0.8,0,1,1); }
  50% { transform: none; animation-timing-function: cubic-bezier(0,0,0.2,1); }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes scaleIn {
  0% { opacity: 0; transform: scale(0.9); }
  100% { opacity: 1; transform: scale(1); }
}

@media (width >= 30rem) {
    .modal-width { width: 20rem; }
    .modal-position { bottom: 6rem; right: 3rem; }
    .modal-trigger-position { bottom: 0.5rem; right: 0.5rem; }
}

:root {
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
}
`;
